// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileLanguageSwitcher_container__jAvzy","selected":"MobileLanguageSwitcher_selected__oYr7_"};